import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Switch from 'rc-switch';
import React, { useCallback } from 'react';
import 'rc-switch/assets/index.css';

var styles = {"container":"panneau-filter-toggle-container","vertical":"panneau-filter-toggle-vertical"};

var _excluded = ["name", "value", "label", "vertical", "onChange", "onClear", "className"];
var propTypes = {
  name: PropTypes.string,
  value: PropTypes.bool,
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
  vertical: PropTypes.bool,
  className: PropTypes.string
};
var defaultProps = {
  name: 'toggle',
  value: false,
  label: null,
  vertical: false,
  className: null
};
var ToggleFilter = function ToggleFilter(_ref) {
  var name = _ref.name,
    value = _ref.value,
    label = _ref.label,
    vertical = _ref.vertical,
    onChange = _ref.onChange,
    onClear = _ref.onClear,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  var isTrue = value !== null && (value === true || value === 'true' || value === 1 || value === '1');
  var onToggleChange = useCallback(function (newValue) {
    if (newValue === false && onClear !== null) {
      onClear();
    } else if (onChange !== null) {
      onChange(newValue);
    }
  }, [onChange, onClear]);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames([styles.container, _defineProperty(_defineProperty({}, styles.vertical, vertical), className, className !== null)])
  }, label !== null ? /*#__PURE__*/React.createElement("span", {
    className: "me-2"
  }, label) : null, /*#__PURE__*/React.createElement(Switch, Object.assign({}, props, {
    name: name,
    checked: isTrue,
    onChange: onToggleChange
  })));
};
ToggleFilter.propTypes = propTypes;
ToggleFilter.defaultProps = defaultProps;

export { ToggleFilter as default };
